import { useRecoilValue } from 'recoil';

import { airQualityState } from '@store';

import { YOrN } from './api/useGetAirQuality';

export const useAirQuality = () => {
  const { data } = useRecoilValue(airQualityState);

  if (!data?.airquality?.length) {
    return null;
  }
  const { airquality } = data;
  // takes up most recent data (it will be taken up in order of air quality forecasts / current observed values / yesterday's values)
  let primaryRecord = airquality[0];

  for (const item of airquality) {
    if (item.valid_time_lap > primaryRecord.valid_time_lap) {
      primaryRecord = item;
    }
  }
  const { data_type: dataType, pollutants } = primaryRecord;
  const { air_quality_cat_idx: categoryIndex, air_quality_cat: descriptor } = pollutants.find(
    ({ primary_pollutant_ind }) => primary_pollutant_ind === YOrN.Y,
  );

  return {
    dataType,
    categoryIndex,
    descriptor,
  };
};
